/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Input,
  Grid,
} from '../../components/index';
import {
  tiposSegregacoesDeMassa,
} from '../../utils/listsSelect';
import User from '../../domain/User';
import * as listUtils from '../../utils/listsSelect';

const RGPS = '01000';

const SegregacaoDeMassa = (props) => {

  const desabilitarSegregacaoMassaSolicitante = () => {
    if (isAcaoNovo()) {
      return false;
    }
    if (isAcaoConsulta() && isSolicitanteIgualAoUsuarioLogado() && isUsuarioLogadoRPPS()) {
      return true;
    }
    if (isAcaoCumprirExigencia() && isSolicitanteIgualAoUsuarioLogado() && isUsuarioLogadoRPPS()) {
      return false;
    }
    if (isAcaoIndeferidos() && isSolicitanteIgualAoUsuarioLogado() && isUsuarioLogadoRPPS()) {
      return false;
    }
    return true;
  }

  const desabilitarSegregacaoMassaDestinatario = () => {
    if ((isAcaoNovo() || isAcaoCumprirExigencia() || isAcaoIndeferidos()) && isUsuarioLogadoRPPS()) {
      return true;
    }
    if (isAcaoConsulta() && isDestinatarioIgualAoUsuarioLogado() && isUsuarioLogadoRPPS()) {
      return true;
    } 
    if (isAcaoRealizarAnalise() && isDestinatarioIgualAoUsuarioLogado() && isDestinatarioRPPS() && isUsuarioLogadoRPPS()) {
      return false;
    }
    return true;
  }

  const isAcaoNovo = () => {
    return (props.estadoFormulario.acao === 'novo');
  }

  const isAcaoCumprirExigencia = () => {
    return (props.estadoFormulario.acao === 'cumprir-exigencia');
  }

  const isAcaoIndeferidos = () => {
    return (props.estadoFormulario.acao === 'indeferidos');
  }

  const isAcaoConsulta = () => {
    return (props.estadoFormulario.acao === 'consulta');
  }

  const isAcaoRealizarAnalise = () => {
    return (props.estadoFormulario.acao === 'realizar-analise');
  }

  const isUsuarioLogadoRPPS = () => {
    return User.logged().isRPPS();
  }

  const isUsuarioLogadoRGPS = () => {
    return User.logged().isRGPS();
  }

  const isDestinatarioRGPS = () => {
    return (props.estadoFormulario.requerimento.destinatario && props.estadoFormulario.requerimento.destinatario.codigo === RGPS);
  }

  const isDestinatarioRPPS = () => {
    return (props.estadoFormulario.requerimento.destinatario && props.estadoFormulario.requerimento.destinatario.codigo !== RGPS);
  }

  const isSolicitanteRPPS = () => {
    return (props.estadoFormulario.requerimento.solicitante && props.estadoFormulario.requerimento.solicitante.codigo !== RGPS);
  }

  const isDestinatarioIgualAoUsuarioLogado = () => {
    if(props.estadoFormulario.requerimento) {
      return ((props.estadoFormulario.requerimento.destinatario && props.estadoFormulario.requerimento.destinatario.cnpj) === User.logged().cnpjDoPapel());
    }
    return false;
  }

  const isSolicitanteIgualAoUsuarioLogado = () => {
    if (props.estadoFormulario.requerimento) {
      return ((props.estadoFormulario.requerimento.solicitante && props.estadoFormulario.requerimento.solicitante.cnpj) === User.logged().cnpjDoPapel());
    }
    return false;
  }

  const exibirBotaoAlterarSegregacaoMassaDestinatario = () => {
    if ( ((isUsuarioLogadoRPPS() && isDestinatarioRPPS())) &&
    (props.estadoFormulario.requerimento && props.estadoFormulario.requerimento.destinatario) &&
    (isAcaoConsulta()) &&
      ((props.estadoFormulario.requerimento.destinatario.cnpj === User.logged().cnpjDoPapel()))) {
        return true;
    }
    return false;
  }

  const exibirBotaoAlterarSegregacaoMassaSolicitante = () => {
    if ( ((isUsuarioLogadoRPPS() && isSolicitanteRPPS())) &&
    (props.estadoFormulario.requerimento && props.estadoFormulario.requerimento.solicitante) &&
    (isAcaoConsulta()) &&
      ((props.estadoFormulario.requerimento.solicitante.cnpj === User.logged().cnpjDoPapel()))) {
        return true;
    }
    return false;
  }

  const diffRequerimento = () => {
    const { tipoRequerimento } = { ...props.estadoFormulario };
    if (tipoRequerimento === 2) {
      return 'pensao';
    }
    return 'aposentadoria';
  }

  const addTiposSegregacaoDeMassaLabel = tipo => {
    if (tipo) {
      return listUtils.getObject(listUtils.tiposSegregacoesDeMassa, Number(tipo)).label;
    }
    return '';
  }

  let labelSegregacaoDeMassaSolicitante = (
    <Grid cols="4 4 4 4">
      <Input
        disabled
        label="Segregação de massa do solicitante"
        value={addTiposSegregacaoDeMassaLabel(props.estadoFormulario.requerimento.tipoSegregacaoSolicitante)}
      />
    </Grid>
  );

  let comboSegregacaoDeMassaSolicitante = (
    <Grid cols="4 4 4 4">
      <Input
        disabled={desabilitarSegregacaoMassaSolicitante()}
        placeholder=""
        label="Segregação de massa do solicitante"
        itemList={tiposSegregacoesDeMassa}
        onChange={e => props.handleChange(e, 'tipoSegregacaoSolicitante')}
        value={props.estadoFormulario.requerimento.tipoSegregacaoSolicitante}
        touched={props.estadoFormulario.touched}
        custom
        exibirBotao={exibirBotaoAlterarSegregacaoMassaSolicitante()}
        onClickDoBotao={() => props.handleModalAlteraSegregacaoMassa('solicitante')}
        hintDoBotao="Alterar segregação de massa do solicitante"
        iconeDoBotao="ico-pencil"
        classe="icone"
      />
    </Grid>
  );

  let labelSegregacaoDeMassaDestinatario = (
    <Grid cols="4 4 4 4">
      <Input
        disabled
        label="Segregação de massa do destinatário"
        value={addTiposSegregacaoDeMassaLabel(props.estadoFormulario.requerimento.tipoSegregacaoDestinatario)}
      />
    </Grid>
  );

  let comboSegregacaoDeMassaDestinatario = (
    <Grid cols="4 4 4 4">
      <Input
        disabled={desabilitarSegregacaoMassaDestinatario()}
        placeholder=""
        label="Segregação de massa do destinatário"
        itemList={tiposSegregacoesDeMassa}
        onChange={e => props.handleChange(e, 'tipoSegregacaoDestinatario')}
        value={props.estadoFormulario.requerimento.tipoSegregacaoDestinatario}
        touched={props.estadoFormulario.touched}
        custom
        exibirBotao={exibirBotaoAlterarSegregacaoMassaDestinatario()}
        onClickDoBotao={() => props.handleModalAlteraSegregacaoMassa('destinatario')}
        hintDoBotao="Alterar segregação de massa do destinatário"
        iconeDoBotao="ico-pencil"
        classe="icone"
      />
    </Grid>
  );
  
  const exibirComboSolicitante = () => {
    let retorno = (diffRequerimento() === 'aposentadoria' ? comboSegregacaoDeMassaSolicitante : labelSegregacaoDeMassaSolicitante);

    if ((isUsuarioLogadoRPPS())) {
      if ( (isAcaoConsulta() || isAcaoCumprirExigencia() || isAcaoIndeferidos() || isAcaoNovo() || isAcaoRealizarAnalise()) &&
      props.estadoFormulario.requerimento.solicitante !== undefined && props.estadoFormulario.requerimento.solicitante.codigo === RGPS) {
        retorno = '';
      }
      return retorno;
    } else {
      //USUARIO LOGADO É RGPS
      if ( (isAcaoConsulta() || isAcaoCumprirExigencia() || isAcaoIndeferidos() || isAcaoRealizarAnalise()) &&
        props.estadoFormulario.requerimento.solicitante !== undefined && props.estadoFormulario.requerimento.solicitante.codigo === RGPS) {
        retorno = '';
      } else if (isAcaoNovo()) {
        retorno = '';
      }
    }
    return retorno;
  }

  const exibirComboDestinatario = () => {
    let retorno = (diffRequerimento() === 'aposentadoria' ? comboSegregacaoDeMassaDestinatario : labelSegregacaoDeMassaDestinatario);

    if ((isAcaoConsulta() || isAcaoCumprirExigencia() || isAcaoIndeferidos() || isAcaoNovo() || isAcaoRealizarAnalise()) && 
    props.estadoFormulario.requerimento.destinatario !== undefined &&
    (props.estadoFormulario.requerimento.destinatario && props.estadoFormulario.requerimento.destinatario.codigo === RGPS)) {
      retorno = '';
    } else {
      if ( (props.estadoFormulario.requerimento.destinatario === RGPS)) {
        retorno = ''; 
      }
    }

    return retorno;
  }

  return (
    <React.Fragment>
      { exibirComboSolicitante() }
      { exibirComboDestinatario() }
    </React.Fragment>      
  );
}

SegregacaoDeMassa.propTypes = {
  estadoFormulario: PropTypes.objectOf(PropTypes.object).isRequired,
  handleChange: PropTypes.func.isRequired,
  handleModalAlteraSegregacaoMassa: PropTypes.func.isRequired,
}.isRequired;

export default SegregacaoDeMassa;



// WEBPACK FOOTER //
// ./src/pages/requerimentos/SegregacaoDeMassa.jsx